export default {
  "0": {
    label: "Ожидание",
    colorBg: "#EBEEF7",
    colorTx: "#566B7D",
  },
  "10": {
    label: "В процессе",
    colorBg: "#E3E8FF",
    colorTx: "#635EF2",
  },
  "20": {
    label: "Завершено",
    colorBg: "#E4FBF1",
    colorTx: "#1CA673",
  },
  "-1": {
    label: "Ошибка",
    colorBg: "#FFEAE7",
    colorTx: "#E85949",
  },
  "-10": {
    label: "Прервано",
    colorBg: "#FFF4E6",
    colorTx: "#F59E0B",
  },
}
